export const UPDATE_CRITERIA_TAB = 'UPDATE_CRITERIA_TAB';
export const UPDATE_EDE_TAB = 'UPDATE_EDE_TAB'
export const UPDATE_IMPORT_TAB = 'UPDATE_IMPORT_TAB'
